"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserTokenClient = void 0;
var _TokenClient = require("../TokenClient");
var _TokenRoutes = require("../TokenRoutes");
/**
 * Shorthand to TokenClient({ url: TokenRoutes.USER_ACCESS })
 */
class UserTokenClient extends _TokenClient.TokenClient {
  constructor() {
    super({
      url: _TokenRoutes.TokenRoutes.USER_ACCESS
    });
  }
}
exports.UserTokenClient = UserTokenClient;
//# sourceMappingURL=UserTokenClient.js.map